import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthenticated',
  // standalone: true,
  // imports: [],
  templateUrl: './unauthenticated.component.html',
  styleUrl: './unauthenticated.component.css'
})
export class UnauthenticatedComponent {

  private router: Router = inject(Router);

  backButtonClicked() {
    location.reload();
  }

}
